<script setup lang="ts">
import { SerializedIncidentReducer } from '@/composables/charts/influx-charts/incident-reducers/IncidentReducers'
import { computed } from 'vue'
import { useDisplay } from 'vuetify'

const model = defineModel<SerializedIncidentReducer | undefined>()

const { mobile } = useDisplay()

const enablePenStateReduction = computed({
  get: () => model.value?.reducerType === 'penState',
  set: (value: boolean) => {
    if (value) {
      model.value = { reducerType: 'penState' }
      return
    }
    model.value = undefined
  },
})
</script>

<template>
  <v-layout-card
    class="pa-0 mb-6"
    variant="flat"
    elevation="0"
  >
    <v-card-title class="pt-0">
      <v-icon
        icon="mdi-chart-line"
        start
      />
      {{ $t('charts.incident_reduction.title') }}
    </v-card-title>
    <v-card-text
      class="py-0"
      :class="{ 'px-0': mobile, 'px-6': !mobile }"
    >
      <v-switch
        v-model="enablePenStateReduction"
        :label="$t('charts.incident_reduction.set_values_to_zero')"
        color="primary"
        hide-details
      />
    </v-card-text>
  </v-layout-card>
</template>
